<template>
    <tab-layout
        :buttons="buttons"
        :permissions="permissions"
        :parameters="[{ key: 'linkedid', value: linkedid }]"
    >
        <template #title>
            {{ more.title }}
        </template>

        <template #content>
            <div class="prelative min-h-100">
                <preloader :display="loading" />
                <div v-if="!loading" id="listing-v1" v-html="htmlData"></div>
            </div>
        </template>
    </tab-layout>
</template>

<script>
import OverviewTabMixin from './OverviewTabMixin';
import { buildUrl } from '../../../helpers';
import EmailMixins from '../../../mixins/EmailMixins';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('corp');

export default {
    mixins: [OverviewTabMixin, EmailMixins],
    props: {
        more: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            htmlData: '',
            response: false,
        };
    },
    computed: {
        ...mapState({
            corpid: 'id',
        }),
        buttons() {
            return (
                this.more?.buttons?.map((button) => {
                    // button.linkedid = this.$store.getters.linkedid
                    // button.linkedtype = this.$store.getters.linkedtype
                    return button;
                }) || []
            );
        },
        permissions() {
            return this.$store.getters.permissions;
        },
        isIndividual() {
            return (
                (this.linkedtype === 'third' &&
                    this.$store.state.third.identity.isCorporation === false) ||
                (this.linkedtype === 'opportunity' && this.company.type === 'person')
            );
        },
    },
    created() {
        EventBus.on('sendemail', () => {
            this.checkEmailProvider({
                template: {
                    type: 'reminderMandate',
                },
                linkedid: this.linkedid,
                type: this.isIndividual ? 'individual' : 'company',
            });
        });
        this.fetch().then(() => {
            this.initListingv1();
        });

        EventBus.on('overviewv2:tablistingv1:refresh', () => {
            this.fetch().then(() => {
                this.initListingv1();
            });
        });
    },
    unmounted() {
        EventBus.off('sendemail');
        EventBus.off('overviewv2:tablistingv1:refresh');
    },
    methods: {
        fetch() {
            return new Promise((resolve, reject) => {
                this.loading = true;
                var params = {
                    action: this.more.action,
                    listing: this.more.listingname,
                    thirdid: this.linkedid,
                    id: this.linkedid,
                    context: this.more.context ? this.more.context : '',
                    prefilter: this.more.prefilter
                        ? buildUrl(this.more.prefilter, [
                            { key: 'linkedid', value: this.linkedid },
                            {
                                key: 'corpid',
                                value: this.$store.getters.dataFetch.sellsyadmin
                                    ? parseInt(this.$store.getters.dataFetch.sellsyadmin.id)
                                    : '',
                            },
                        ])
                        : '',
                    type: this.more.type ? this.more.type : '',
                    doctype: this.more.doctype ? this.more.doctype : '',
                    relatedtype: this.more.relatedtype ? this.more.relatedtype : '',
                    relatedid: this.more.relatedid
                        ? buildUrl(this.more.relatedid, [{ key: 'linkedid', value: this.linkedid }])
                        : '',
                    corpid: this.more.corpid
                        ? parseInt(
                            buildUrl(this.more.corpid, [
                                { key: 'linkedid', value: this.linkedid },
                                {
                                    key: 'corpid',
                                    value: this.$store.getters.dataFetch.sellsyadmin
                                        ? parseInt(this.$store.getters.dataFetch.sellsyadmin.id)
                                        : '',
                                },
                            ]),
                        )
                        : '',
                };
                axios.post(this.more.url, params).then((response) => {
                    if (this.more.tabType == 'total' && response.data[this.more.callbackKeyName]) {
                        this.htmlData = response.data[this.more.callbackKeyName];
                        this.loading = false;
                        resolve();
                    } else {
                        if (response.data.listing !== undefined) {
                            this.htmlData = response.data.listing;
                            this.response = response.data;
                            this.loading = false;
                            resolve();
                        } else if (
                            this.more.callbackKeyName &&
                            this.more.callbackKeyName != '' &&
                            response.data[this.more.callbackKeyName] != undefined
                        ) {
                            this.htmlData = response.data[this.more.callbackKeyName];
                            this.response = response.data;
                            this.loading = false;
                            resolve();
                        } else {
                            this.htmlData = response.data.error;
                        }
                    }
                });
            });
        },
        initListingv1() {
            Listing.init(this.response.prefix);
            switch (this.response.listingname) {
                case 'thirdproposal':
                case 'opportunityproposal':
                    var options = {
                        data: {
                            action: 'updateListingTab',
                            thirdid: this.linkedid,
                            listing: 'proposal',
                            context: this.more.context,
                            prefilter: this.more.prefilter
                                ? buildUrl(this.more.prefilter, [
                                    { key: 'linkedid', value: this.linkedid },
                                ])
                                : '',
                        },
                        success: function (data) {
                            Listing.refresh(data.listingName, data, data[data.metadatasName]);
                        },
                        dataType: 'json',
                    };
                    MyForm.prepare(this.response.listingname + 'FilterForm', 'tabs', options);
                    break;
                case 'mandates':
                    var options = {
                        success: function (data) {
                            Listing.refresh('mandatesListing', data, data.mandates_metadatas);
                        },
                        data: { action: 'updateListingTab', thirdid: this.linkedid },
                        dataType: 'json',
                    };
                    MyForm.prepare('mandatesFilterForm', 'gocardless_mandates', options);
                    break;
                case 'docthirdspurOrder':
                case 'docthirdspurDelivery':
                case 'docthirdspurInvoice':
                case 'docthirdspurCreditNote':
                    var options = {
                        success: function (data) {
                            Listing.refresh(data.listingName, data, data[data.metadatasName]);
                        },
                        dataType: 'json',
                    };
                    MyForm.prepare(
                        this.response.listingname + 'FilterForm',
                        'third&action=updateDocsListing&thirdid=' +
                            this.linkedid +
                            '&doctype=' +
                            this.more.doctype,
                        options,
                    );
                    break;
                case 'contactmailinglists':
                case 'contactcampaigns':
                    var options = {
                        success: function (data) {
                            Listing.refresh(data.listingName, data, data[data.metadatasName]);
                        },
                        dataType: 'json',
                    };
                    MyForm.prepare(
                        this.response.listingname + 'FilterForm',
                        'massmailing_ajax&action=updateMassMailingContactListingTab&type=' +
                            this.more.type +
                            '&id=' +
                            this.linkedid +
                            '&listing=' +
                            this.more.listingname,
                        options,
                    );

                    break;
                default:
                    Timetracking.initListiingGraph();
                    var options = {
                        data: {
                            action: 'updateListingTab',
                            thirdid: this.linkedid,
                            listing: this.more.listingname,
                        },
                        success: function (data) {
                            Listing.refresh(data.listingName, data, data[data.metadatasName]);
                        },
                        dataType: 'json',
                    };
                    MyForm.prepare(this.response.listingname + 'FilterForm', 'third', options);
                    break;
            }
            Qtip.init();
            MyFacture.customForm();
        },
    },

    components: {
        Preloader,
        TabLayout,
    },
};
</script>

<style lang="scss">
#listing-v1 > header {
    display: none;
}
#listing-v1 .listingTools .export {
    display: none;
}
#listing-v1 #massmailingContactProfile h3 {
    display: none;
}
</style>
